// material-ui
import { useTheme } from "@mui/material/styles";
import { Box } from "@mui/material";

const Footer = ({ }) => {
  const theme = useTheme();

  return (
    <>
        <Box
            sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#eceef0",
            paddingTop: "10px",
            marginTop: "auto"
            }}>
            <p style={{margin: '0'}}>Copyright <sup>©</sup>Geograph {new Date().getFullYear()}</p>
        </Box>
    </>
  );
};

export default Footer;
